import React, { useState, useEffect } from 'react';
import { Clock, CheckCircle, XCircle, TrendingUp, TrendingDown, DollarSign, Copy, ExternalLink, Search, BarChart2, Zap, Wallet, AlertCircle } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { apiFetch } from '../App';

const T = { bg2:'#0d1114', border:'rgba(255,255,255,.06)', text:'#e8eaeb', muted:'#4a5a63', green:'#00c566' };

export default function Markets() {
  const [markets, setMarkets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [lpModal, setLpModal] = useState(null);
  const [lpAmount, setLpAmount] = useState('');
  const [lpLoading, setLpLoading] = useState(false);
  const [copied, setCopied] = useState(null);
  const [showDeposit, setShowDeposit] = useState(false);
  const [walletInfo, setWalletInfo] = useState(null);
  const [walletLoading, setWalletLoading] = useState(false);
  const [addrCopied, setAddrCopied] = useState(false);




  async function submitLp() {
    if (!lpAmount || parseFloat(lpAmount) < 1) return alert('Minimum $1 USDC');
    setLpLoading(true);
    try {
      const token = localStorage.getItem('np_creator_token');
      const res = await fetch('https://api.naijapredict.net/api/dollar/lp/deposit', {
        method:'POST', headers:{'Content-Type':'application/json',Authorization:'Bearer '+token},
        body: JSON.stringify({ marketId: lpModal.id, usdcAmount: lpAmount })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      alert('Liquidity added! TX: '+data.txHash?.slice(0,20)+'...');
      setLpModal(null); setLpAmount('');
    } catch(e) { alert('Error: '+e.message); }
    finally { setLpLoading(false); }
  }

  async function fetchWallet() {
    if (walletInfo) return;
    setWalletLoading(true);
    try {
      const token = localStorage.getItem('np_creator_token');
      const res = await fetch('https://api.naijapredict.net/api/creator/wallet', {
        headers: { Authorization: 'Bearer ' + token }
      });
      const data = await res.json();
      setWalletInfo(data);
    } catch(e) { alert('Error fetching wallet: '+e.message); }
    finally { setWalletLoading(false); }
  }

  function openDeposit() {
    setShowDeposit(d=>!d);
    fetchWallet();
  }

  function copyAddress() {
    if (!walletInfo?.address) return;
    navigator.clipboard?.writeText(walletInfo.address).then(()=>{
      setAddrCopied(true);
      setTimeout(()=>setAddrCopied(false), 2000);
    });
  }

  function copyLink(id) {
    const link = `https://t.me/NaijaPredict_Bot/app?startapp=dollar_${id}`;
    navigator.clipboard?.writeText(link).then(()=>{
      setCopied(id);
      setTimeout(()=>setCopied(null), 2000);
    });
  }

  async function submitLp() {
    if (!lpAmount || parseFloat(lpAmount) < 1) return alert('Minimum $1 USDC');
    setLpLoading(true);
    try {
      const token = localStorage.getItem('np_creator_token');
      const res = await fetch('https://api.naijapredict.net/api/dollar/lp/deposit', {
        method:'POST',
        headers:{'Content-Type':'application/json', Authorization:'Bearer '+token},
        body: JSON.stringify({ marketId: lpModal.id, usdcAmount: lpAmount })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      alert('Liquidity added! TX: '+data.txHash?.slice(0,20)+'...');
      setLpModal(null); setLpAmount('');
    } catch(e) { alert('Error: '+e.message); }
    finally { setLpLoading(false); }
  }

  useEffect(() => {
    apiFetch('/api/creator/markets').then(setMarkets).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  const filtered = markets.filter(m => {
    const ms = m.question.toLowerCase().includes(search.toLowerCase());
    const mf = filter==='all'||(filter==='active'&&m.state===0)||(filter==='resolved'&&m.state===1)||(filter==='cancelled'&&m.state===2);
    return ms && mf;
  });

  const stateColor = {0:'#00c566',1:'#f5c842',2:'#ff4444'};
  const stateLabel = {0:'Active',1:'Resolved',2:'Cancelled'};
  const StateIcon  = {0:Clock,1:CheckCircle,2:XCircle};

  return (
    <div>
      {/* LP Modal */}
      {lpModal&&(
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.85)', zIndex:999, display:'flex', alignItems:'flex-end', justifyContent:'center' }} onClick={()=>setLpModal(null)}>
          <div style={{ background:'#0d1114', borderRadius:'20px 20px 0 0', width:'100%', maxWidth:480, padding:'24px 20px 40px', border:`1px solid ${T.border}`, borderBottom:'none' }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:16, fontWeight:800, color:'#e8eaeb', marginBottom:4 }}>Add Liquidity</div>
            <div style={{ fontSize:13, color:T.muted, marginBottom:16, lineHeight:1.5 }}>{lpModal.question}</div>
            <div style={{ background:'rgba(0,197,102,.05)', border:'1px solid rgba(0,197,102,.15)', borderRadius:10, padding:'10px 14px', marginBottom:16, fontSize:12, color:T.muted, lineHeight:1.7 }}>
              Earn <strong style={{ color:T.green }}>2% of every trade</strong> proportional to your share. Pool: <strong style={{ color:T.green }}>${parseFloat(lpModal.totalCollateral||0).toFixed(2)} USDC</strong>
            </div>
            <label style={{ display:'block', fontSize:12, color:T.muted, fontWeight:600, letterSpacing:.5, marginBottom:6 }}>AMOUNT (USDC)</label>
            <input type="number" placeholder="e.g. 10.00" value={lpAmount} onChange={e=>setLpAmount(e.target.value)} min="1"
              style={{ background:'rgba(255,255,255,.04)', border:`1px solid ${T.border}`, borderRadius:10, padding:'13px 14px', color:'#e8eaeb', fontSize:16, width:'100%', outline:'none', fontFamily:'monospace', marginBottom:12 }}/>
            <div style={{ display:'flex', gap:8, marginBottom:16 }}>
              {['5','10','25','50'].map(v=>(
                <button key={v} onClick={()=>setLpAmount(v)} style={{ flex:1, padding:'8px', borderRadius:8, border:`1px solid ${lpAmount===v?'rgba(0,197,102,.3)':T.border}`, background:lpAmount===v?'rgba(0,197,102,.1)':'rgba(255,255,255,.03)', color:lpAmount===v?T.green:T.muted, cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'inherit' }}>${v}</button>
              ))}
            </div>
            <button onClick={submitLp} disabled={lpLoading||!lpAmount||parseFloat(lpAmount)<1}
              style={{ width:'100%', padding:13, borderRadius:12, border:'none', background:'linear-gradient(135deg,#00c566,#00a854)', color:'#000', fontWeight:700, fontSize:14, cursor:'pointer', marginBottom:10, fontFamily:'inherit', opacity:lpLoading||!lpAmount?.6:1 }}>
              {lpLoading?'Processing...':'Deposit $'+lpAmount+' USDC'}
            </button>
            <button onClick={()=>setLpModal(null)} style={{ width:'100%', padding:10, background:'transparent', border:'none', color:T.muted, fontSize:13, cursor:'pointer', fontFamily:'inherit' }}>Cancel</button>
          </div>
        </div>
      )}
      {/* LP Modal */}
      {lpModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.85)', zIndex:999, display:'flex', alignItems:'flex-end', justifyContent:'center' }} onClick={()=>setLpModal(null)}>
          <div style={{ background:'#0d1114', borderRadius:'20px 20px 0 0', width:'100%', maxWidth:480, padding:'24px 20px 40px', border:`1px solid ${T.border}`, borderBottom:'none' }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:16, fontWeight:800, marginBottom:4 }}>Add Liquidity</div>
            <div style={{ fontSize:13, color:T.muted, marginBottom:4, lineHeight:1.5 }}>{lpModal.question}</div>
            <div style={{ fontSize:12, color:T.green, marginBottom:20 }}>Earn 2% of every trade proportional to your pool share</div>
            <div style={{ background:'rgba(0,197,102,.04)', border:`1px solid rgba(0,197,102,.12)`, borderRadius:10, padding:'10px 14px', marginBottom:16, fontSize:12, color:T.muted, lineHeight:1.7 }}>
              Current pool: <strong style={{ color:T.green }}>${parseFloat(lpModal.totalCollateral||0).toFixed(2)} USDC</strong>
            </div>
            <label style={{ display:'block', fontSize:12, color:T.muted, fontWeight:600, letterSpacing:.5, marginBottom:6 }}>AMOUNT (USDC)</label>
            <input type="number" placeholder="e.g. 10.00" value={lpAmount} onChange={e=>setLpAmount(e.target.value)} min="1" style={{ marginBottom:14, background:'rgba(255,255,255,.04)', border:`1px solid ${T.border}`, borderRadius:10, padding:'12px 14px', color:'#e8eaeb', fontSize:16, width:'100%', outline:'none', fontFamily:'monospace' }}/>
            <div style={{ display:'flex', gap:8, marginBottom:14 }}>
              {['5','10','25','50'].map(v=>(
                <button key={v} onClick={()=>setLpAmount(v)} style={{ flex:1, padding:'8px', borderRadius:8, border:`1px solid ${lpAmount===v?'rgba(0,197,102,.3)':T.border}`, background:lpAmount===v?'rgba(0,197,102,.1)':'rgba(255,255,255,.03)', color:lpAmount===v?T.green:T.muted, cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'inherit' }}>${v}</button>
              ))}
            </div>
            <button onClick={submitLp} disabled={lpLoading||!lpAmount} style={{ width:'100%', padding:13, borderRadius:12, border:'none', background:'linear-gradient(135deg,#00c566,#00a854)', color:'#000', fontWeight:700, fontSize:14, cursor:'pointer', marginBottom:10, fontFamily:'inherit', opacity:lpLoading||!lpAmount?.6:1 }}>
              {lpLoading?'Processing...':'Deposit $'+lpAmount+' USDC'}
            </button>
            <button onClick={()=>setLpModal(null)} style={{ width:'100%', padding:10, background:'transparent', border:'none', color:T.muted, fontSize:13, cursor:'pointer', fontFamily:'inherit' }}>Cancel</button>
          </div>
        </div>
      )}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4, flexWrap:'wrap', gap:10 }}>
        <h1 style={{ fontSize:'clamp(20px,4vw,28px)', fontWeight:800 }}>My Markets</h1>
        <button onClick={openDeposit}
          style={{ padding:'8px 16px', borderRadius:10, border:'1px solid rgba(0,197,102,.25)', background:'rgba(0,197,102,.06)', color:T.green, cursor:'pointer', fontSize:13, fontWeight:600, display:'flex', alignItems:'center', gap:6, fontFamily:'inherit' }}>
          <Wallet size={14}/> Fund Wallet
        </button>
      </div>
      <p style={{ fontSize:14, color:T.muted, marginBottom: showDeposit?12:20 }}>All prediction markets you've created</p>

      {/* Deposit Panel */}
      {showDeposit&&(
        <div style={{ background:'rgba(0,197,102,.04)', border:'1px solid rgba(0,197,102,.15)', borderRadius:16, padding:20, marginBottom:20 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
            <div style={{ fontSize:15, fontWeight:700, color:T.green, display:'flex', alignItems:'center', gap:8 }}><Wallet size={16}/> Fund Your Creator Wallet</div>
            <button onClick={()=>setShowDeposit(false)} style={{ background:'rgba(255,255,255,.06)', border:'none', color:T.muted, cursor:'pointer', width:28, height:28, borderRadius:6, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'inherit', fontSize:16 }}>×</button>
          </div>

          {walletLoading ? (
            <div style={{ textAlign:'center', padding:'24px 0', color:T.muted, fontSize:14 }}>Loading wallet...</div>
          ) : walletInfo ? (<>
            {/* Balance */}
            <div style={{ background:'rgba(255,255,255,.03)', border:`1px solid ${T.border}`, borderRadius:10, padding:'10px 16px', marginBottom:14, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:13, color:T.muted }}>USDC Balance</span>
              <span style={{ fontSize:16, fontWeight:800, color:T.green }}>${parseFloat(walletInfo.balance||0).toFixed(4)} USDC</span>
            </div>

            {/* QR Code */}
            <div style={{ display:'flex', justifyContent:'center', marginBottom:14 }}>
              <div style={{ background:'#fff', padding:14, borderRadius:14 }}>
                <QRCodeSVG value={walletInfo.address} size={160} level="H"/>
              </div>
            </div>

            {/* Address */}
            <div style={{ background:'rgba(255,255,255,.03)', border:`1px solid ${T.border}`, borderRadius:10, padding:14, marginBottom:12 }}>
              <div style={{ fontSize:11, color:T.muted, fontWeight:600, letterSpacing:.5, marginBottom:8 }}>YOUR USDC ADDRESS (ETHEREUM NETWORK)</div>
              <div style={{ fontSize:12, color:T.green, fontFamily:'monospace', wordBreak:'break-all', lineHeight:1.7, marginBottom:10 }}>{walletInfo.address}</div>
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={copyAddress}
                  style={{ flex:1, padding:'8px', borderRadius:8, border:`1px solid ${addrCopied?'rgba(0,197,102,.4)':T.border}`, background:addrCopied?'rgba(0,197,102,.1)':'rgba(255,255,255,.04)', color:addrCopied?T.green:T.muted, cursor:'pointer', fontSize:12, fontWeight:600, display:'flex', alignItems:'center', justifyContent:'center', gap:5, fontFamily:'inherit' }}>
                  <Copy size={12}/>{addrCopied?'Copied!':'Copy Address'}
                </button>
                <a href={walletInfo.etherscanUrl} target="_blank" rel="noreferrer"
                  style={{ flex:1, padding:'8px', borderRadius:8, border:`1px solid ${T.border}`, background:'rgba(255,255,255,.04)', color:T.muted, fontSize:12, fontWeight:600, display:'flex', alignItems:'center', justifyContent:'center', gap:5, textDecoration:'none' }}>
                  <ExternalLink size={12}/> Etherscan
                </a>
              </div>
            </div>

            {/* Warning */}
            <div style={{ background:'rgba(245,200,66,.05)', border:'1px solid rgba(245,200,66,.15)', borderRadius:10, padding:'10px 14px', marginBottom:12, display:'flex', gap:8, alignItems:'flex-start' }}>
              <AlertCircle size={13} color="#f5c842" style={{ flexShrink:0, marginTop:1 }}/>
              <div style={{ fontSize:12, color:'#f5c842', lineHeight:1.7 }}>
                Send only <strong>USDC</strong> on <strong>Ethereum</strong> network. Min $5 needed for liquidity. Get free testnet USDC at{' '}
                <a href="https://faucet.circle.com" target="_blank" rel="noreferrer" style={{ color:T.green }}>faucet.circle.com</a>
              </div>
            </div>

            {/* Exchanges */}
            <div style={{ fontSize:11, color:T.muted, marginBottom:8, fontWeight:600 }}>SUPPORTED EXCHANGES</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
              {['Binance','Coinbase','OKX','Bybit','Kraken','KuCoin'].map(ex=>(
                <span key={ex} style={{ background:'rgba(255,255,255,.04)', border:`1px solid ${T.border}`, borderRadius:6, padding:'4px 10px', fontSize:11, color:T.muted }}>{ex}</span>
              ))}
            </div>
          </>) : (
            <div style={{ textAlign:'center', padding:'16px 0', color:T.muted, fontSize:13 }}>Failed to load wallet info</div>
          )}
        </div>
      )}

      <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginBottom:20 }}>
        <div style={{ position:'relative', flex:'1 1 200px' }}>
          <Search size={14} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:T.muted }}/>
          <input placeholder="Search markets..." value={search} onChange={e=>setSearch(e.target.value)} style={{ paddingLeft:36 }}/>
        </div>
        <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
          {['all','active','resolved','cancelled'].map(f=>(
            <button key={f} onClick={()=>setFilter(f)}
              style={{ padding:'8px 14px', borderRadius:8, border:`1px solid ${filter===f?'rgba(0,197,102,.3)':T.border}`, background:filter===f?'rgba(0,197,102,.08)':'rgba(255,255,255,.03)', color:filter===f?T.green:T.muted, cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'inherit', textTransform:'capitalize' }}>
              {f}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:40, color:T.muted }}>Loading...</div>
      ) : filtered.length === 0 ? (
        <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:48, textAlign:'center', color:T.muted }}>
          <BarChart2 size={30} style={{ marginBottom:12, opacity:.4 }}/>
          <div style={{ fontSize:15, fontWeight:600, marginBottom:4 }}>No markets found</div>
          <div style={{ fontSize:13 }}>Create your first market to start earning royalties</div>
        </div>
      ) : filtered.map(m => {
        const SI = StateIcon[m.state]||Clock;
        return (
          <div key={m.id} style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:18, marginBottom:12 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12, marginBottom:12 }}>
              <div style={{ fontSize:14, fontWeight:600, lineHeight:1.5, flex:1 }}>{m.question}</div>
              <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                <button onClick={()=>copyLink(m.id)}
                  style={{ padding:'5px 10px', borderRadius:8, background:copied===m.id?'rgba(0,197,102,.1)':'rgba(255,255,255,.04)', border:`1px solid ${copied===m.id?'rgba(0,197,102,.3)':T.border}`, cursor:'pointer', display:'flex', alignItems:'center', gap:4, color:copied===m.id?T.green:T.muted, fontSize:11, fontWeight:600, fontFamily:'inherit' }}>
                  <Copy size={11}/>{copied===m.id?'Copied!':'Copy'}
                </button>
              </div>
            </div>
            <div style={{ height:6, background:'rgba(255,255,255,.06)', borderRadius:3, overflow:'hidden', marginBottom:8 }}>
              <div style={{ height:'100%', width:(m.yesPct||50)+'%', background:'linear-gradient(90deg,#00c566,#f5c842)', borderRadius:3 }}/>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, marginBottom:10 }}>
              <span style={{ color:T.green, fontWeight:600 }}>YES {m.yesPct||50}%</span>
              <span style={{ color:'#ff4444', fontWeight:600 }}>NO {m.noPct||50}%</span>
            </div>
            {/* Sponsored tag */}
            <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:10 }}>
              <div style={{ display:'flex', alignItems:'center', gap:4, background:'rgba(245,200,66,.06)', border:'1px solid rgba(245,200,66,.18)', borderRadius:20, padding:'3px 8px' }}>
                <Zap size={10} color="#f5c842" strokeWidth={2}/>
                <span style={{ fontSize:10, color:'#f5c842', fontWeight:600 }}>Sponsored by @{m.creatorUsername||'creator'}</span>
              </div>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:12, color:T.muted, marginBottom:m.state===0?10:0 }}>
              <span style={{ display:'flex', alignItems:'center', gap:4, color:stateColor[m.state], fontWeight:600 }}>
                <SI size={11}/>{stateLabel[m.state]}
              </span>
              <span>Pool: ${parseFloat(m.totalCollateral||0).toFixed(2)} USDC</span>
            </div>
            {/* LP Button */}
            {m.state===0&&(
              <button onClick={()=>{ setLpModal(m); setLpAmount(''); }}
                style={{ width:'100%', padding:'8px', borderRadius:8, border:'1px solid rgba(0,197,102,.2)', background:'rgba(0,197,102,.05)', color:T.green, cursor:'pointer', fontSize:12, fontWeight:600, display:'flex', alignItems:'center', justifyContent:'center', gap:5, fontFamily:'inherit' }}>
                <TrendingUp size={12}/> Add Liquidity — Earn 2%
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
